import React, { useState, useEffect } from "react";
import {
  DataGrid,
  GridToolbarContainer,
  GridToolbarExport,
} from "@material-ui/data-grid";
import { getUsersList, ListarAsistencia } from "../utils/Actions";
import { Typography, Grid } from "@material-ui/core";
import Avatar from "@material-ui/core/Avatar";
import _, { isEmpty, size } from "lodash";
import moment from "moment/min/moment-with-locales";
import CheckCircle from "@material-ui/icons/CheckCircle";
import { GRID_DEFAULT_LOCALE_TEXT } from "../config/localeDatagrid";
import Switch from "@material-ui/core/Switch";
import Button from "@material-ui/core/Button";
import { useHistory } from "react-router-dom";
import { Loading } from "../atoms";
import { Link } from "react-router-dom";
import CancelIcon from "@material-ui/icons/Cancel";
import PersonPinIcon from "@material-ui/icons/PersonPin";
import { Input } from "@material-ui/core";
import TextField from "@material-ui/core/TextField";
import WatchLaterIcon from "@material-ui/icons/WatchLater";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";

moment.locale("es");

export default function Journal() {
  const [state, setstate] = useState([]);
  const [visible, setVisible] = useState(false);
  const [monthfilter, setmonthfilter] = useState(
    moment().startOf("month").format("YYYY-MM-DD hh:mm")
  );
  let history = useHistory();

  const [columns, setcolumns] = useState();

  const startOfMonth = moment().startOf("month").format("YYYY-MM-DD hh:mm");
  const endOfMonth = moment().endOf("month").format("YYYY-MM-DD hh:mm");

  useEffect(() => {
    (async () => {
      console.log(monthfilter);
      await getDaysInMonth();
    })();
  }, [monthfilter]);

  function GetCheck(number) {
    const NUMBERSUM = 9999999999999;
    console.log(number.number);
    if (Number(number.number) < 1) {
      return <CancelIcon style={{ color: "#F44336" }} />;
    } else {
      return (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {Number(number.number) > 1
            ? minsToHHMMSS(number.number)
            : number.number + " "}

          {Number(number.number) > 1 ? (
            <PersonPinIcon style={{ color: "#ff9800", fontSize: 28 }} />
          ) : (
            <CheckCircle style={{ color: "#4CAF50" }} />
          )}
        </div>
      );
    }
  }

  const ExportCSV = ({ csvData, fileName }) => {
    let datauserexport = [];

    /*csvData.map((item) => {
      const data = {
        ID: item.id,
        RUTA_FOTO: item.photo,
        NOMBRE: item.name,
        APELLIDO: item.lastname,
        USUARIO: item.employeenumber,
        FECHA_CREACION: item.createdAt,
        ROL: getRolDescription(item.rol),
        CUENTA: item.accountAsignedName,
        ESTATUS: item.status ? "Activo" : "Desactivo",
      };
      datauserexport.push(data);
    });*/

    const fileType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const fileExtension = ".xlsx";

    const exportToCSV = (csvData, fileName) => {
      const ws = XLSX.utils.json_to_sheet(csvData);
      const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
      const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
      const data = new Blob([excelBuffer], { type: fileType });
      FileSaver.saveAs(data, fileName + fileExtension);
    };

    return (
      <Button
        variant="outlined"
        color="secondary"
        onClick={(e) => exportToCSV(csvData, fileName)}
      >
        Exportar a Excel
      </Button>
    );
  };

  function minsToHHMMSS(param) {
    let mins_num = parseFloat(param, 10); // don"t forget the second param
    let hours = Math.floor(mins_num / 60);
    let minutes = Math.floor(mins_num - (hours * 3600) / 60);
    let seconds = Math.floor(mins_num * 60 - hours * 3600 - minutes * 60);

    // Appends 0 when unit is less than 10
    if (hours < 10) {
      hours = "0" + hours;
    }
    if (minutes < 10) {
      minutes = "0" + minutes;
    }
    if (seconds < 10) {
      seconds = "0" + seconds;
    }
    return hours + ":" + minutes;
  }

  async function getDaysInMonth() {
    //nombre, dia, horas trabajadas
    setVisible(true);
    let dataset = [];

    const startOfMonth = moment(monthfilter)
      .startOf("month")
      .format("YYYY-MM-DD hh:mm");
    const endOfMonth = moment(monthfilter)
      .endOf("month")
      .format("YYYY-MM-DD hh:mm");

    const datos = (await ListarAsistencia(startOfMonth, endOfMonth)).data;
    const orderby = _.sortBy(datos, (o) => o.user);

    const date = new Date(moment().startOf("month").format("YYYY-MM-DD hh:mm"));
    const month = date.getMonth();
    let usuarioactual = "";
    let usuarioanterior = "";

    /**************OBTENER LA CANTIDAD DE DÍAS****************/
    let days = [];
    let daysArray = [];
    let dayNumber = 1;
    let daynumberArray = [];
    while (date.getMonth() === month) {
      days.push(new Date(date));
      date.setDate(date.getDate() + 1);
      daynumberArray.push(dayNumber);
      daysArray.push({
        field: (dayNumber++).toString(),
        renderCell: (params) => (
          <Typography>
            <GetCheck number={params.value} />
          </Typography>
        ),
      });
    }
    const columnas = [
      {
        field: "id",
        headerName: "Nombre",
        width: 200,
        valueGetter: (params) =>
          `${params.getValue("name") || ""} ${
            params.getValue("lastname") || ""
          }`,
      },
      ...daysArray,
    ];

    setcolumns(columnas);
    let objectday = {};
    let dataresponse = [];
    if (size(orderby) > 0) {
      orderby.forEach((item) => {
        const userdata = { name: "", lastname: "", user: "", id: "" };
        let fecha = item.registerday.toDate().getDate();
        usuarioactual = item.user;

        //si es la primera vez o el usuario ya se insertó antes
        if (usuarioactual !== usuarioanterior) {
          usuarioanterior = item.user;
          userdata.lastname = item.lastname;
          userdata.name = item.name;
          userdata.user = item.user;
          userdata.id = item.user;

          //Obtener día que hay que guardar.
          objectday = { ...objectday, ...userdata };
          daynumberArray.forEach((dia) => {
            if (fecha === dia) {
              if (
                _.get(item, "minutesworked", 9999999999999) === 9999999999999
              ) {
                console.log("NO TIENE MINUTOS");
                let diff = new Date() - item.registerday.toDate();
                let hh = Math.floor(diff / 1000 / 60 / 60);
                let resultInMinutes = Math.round(diff / 60000);
                objectday = {
                  ...objectday,
                  [dia]: resultInMinutes,
                };
              } else {
                objectday = {
                  ...objectday,
                  [dia]: item.minutesworked
                    ? minsToHHMMSS(item.minutesworked)
                    : 0,
                };
              }
            } else {
              objectday = { ...objectday, [dia]: 0 };
            }
          });
          //se almacena el usuario con el primer día
          dataresponse.push(objectday);
        } else {
          let currentindex = dataresponse.findIndex(
            (response) => response.user === usuarioactual
          );
          let objetoindex = dataresponse[currentindex];
          //optienes la copia
          //borras la copia del arreglo
          if (currentindex > -1) {
            dataresponse.splice(currentindex, 1);
          }
          objectday = { ...objetoindex };

          //modificas la copia para agregarle el día adicional
          daynumberArray.forEach((dia) => {
            if (fecha === dia) {
              if (
                _.get(item, "minutesworked", 9999999999999) === 9999999999999
              ) {
                console.log("NO TIENE MINUTOS");
                let diff = new Date() - item.registerday.toDate();
                let hh = Math.floor(diff / 1000 / 60 / 60);
                let resultInMinutes = Math.round(diff / 60000);
                objectday = {
                  ...objectday,
                  [dia]: resultInMinutes,
                };
              } else {
                objectday = {
                  ...objectday,
                  [dia]: item.minutesworked
                    ? minsToHHMMSS(item.minutesworked)
                    : 0,
                };
              }
            }
          });

          //agregas el dato al array
          dataresponse.push(objectday);
        }
      });

      /*****RECORRER ASISTENCIAS POR DIA POR USUARIO -ORDENAR POR USUARIO ID*/
    }
    setstate(dataresponse);
    setVisible(false);

    return days;
  }

  useEffect(() => {
    (async () => {
      setVisible(true);
      // setstate((await getUsersList()).data);
      await getDaysInMonth();
      setVisible(false);
    })();
  }, []);

  function CustomToolbar() {
    return (
      <GridToolbarContainer style={{ justifyContent: "flex-end", height: 80 }}>
        <ExportCSV csvData={state} fileName={"Asistencias"} />
      </GridToolbarContainer>
    );
  }

  return (
    size(columns) > 0 && (
      <Grid
        container
        direction="column"
        style={{ height: "100vh", backgroundColor: "#fff", borderRadius: 5 }}
      >
        <Typography
          variant="h5"
          style={{ marginBottom: 20, marginLeft: 30, marginTop: 20 }}
        >
          <WatchLaterIcon />
          Asistencias
        </Typography>
        <div style={{ marginBottom: 20, marginLeft: 30 }}>
          <TextField
            id="outlined-basic"
            variant="outlined"
            type="month"
            onChange={(e) => {
              setmonthfilter(e.target.value + "-01");
            }}
          />
        </div>
        <DataGrid
          rows={state}
          columns={columns}
          autoPageSize={true}
          localeText={GRID_DEFAULT_LOCALE_TEXT}
          components={{
            Toolbar: CustomToolbar,
          }}
        />

        <Loading visible={visible} setVisible={setVisible} />
      </Grid>
    )
  );
}
